import { IResourceList } from 'src/components/challenge/ChallengeInterfaces';
import { ResourceTypeDetailEnum } from 'src/shared/enums';
import { IExperienceProgress } from 'src/shared/models/experienceProgress.model';

const {
  EXPERIENCE_PROGRESS_FULL,
  EXPERIENCE_PROGRESS_HALF,
  EXPERIENCE_PROGRESS_NONE,
} = ResourceTypeDetailEnum;

export const buildExperienceProgress = (
  resource: IResourceList
): IExperienceProgress => {
  const { resourceDetailList, idResource, name: title } = resource;
  let item: IExperienceProgress;

  resourceDetailList
    .filter(({ status }) => status)
    .forEach(({ idResourceTypeD: { idResourceTypeD }, value }) => {
      switch (idResourceTypeD) {
        case EXPERIENCE_PROGRESS_FULL:
          item = {
            ...item,
            fullProgress: value,
          };
          break;
        case EXPERIENCE_PROGRESS_HALF:
          item = {
            ...item,
            halfProgress: value,
          };
          break;
        case EXPERIENCE_PROGRESS_NONE:
          item = {
            ...item,
            noProgress: value,
          };
          break;
      }
    });

  return {
    ...item,
    idResource,
    title,
  };
};
